<template>
<!-- 邀请语编辑 -->
    <div class="el-card  pd20">
         <!-- 返回 -->
        <div class="cancel-box">
            <el-button type="info" icon="el-icon-arrow-left"  @click="$router.go(-1)"  size="medium">返回邀请语列表</el-button>
        </div>
        <el-divider></el-divider>
        <el-form :rules="rules" class="invite-form" ref="form" :model="form" label-width="80px">
            <el-form-item label="邀请语" prop="describe"  :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.describe"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="状态" prop="state"  :label-width="formLabelWidth">
                <el-select v-model="form.state" placeholder="请选择状态">
                <el-option label="开启" :value="0">开启</el-option>
                <el-option label="关闭" :value="1">关闭</el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="课程" prop="course_id"  :label-width="formLabelWidth">
                <el-select v-model="form.course_id" placeholder="请选择关联课程">
                    <el-option  v-for="(item,index) in course_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item :label-width="formLabelWidth">
                <el-button type="primary" @click="submitForm('form')">保存</el-button>
            </el-form-item>
            </el-form>
    </div>
</template>

<script>
import { inviteAdd,missionCamp,inviteEdit } from "@/api/operating";
export default {
    data() {
        return{
            is_edit:false,
            formLabelWidth:'120px',
            form:{
                describe:"",
                course_id:null,
                state:null
            },
            course_list:[],
            //这是一个验证规则
            rules:{
                course_id: [{
                        required: true,//是否必填
                        message: '请选择课程',//错误提示信息
                        trigger: 'change'//检验方式（blur为鼠标点击其他地方，）
                    }
                ],
                describe:[{
                    required: true,
                    message: '请输入拼团价格',
                    trigger: 'blur'
                }],
                state:[{
                    required: true,
                    message: '请选择拼团状态',
                    trigger: 'change'
                }]
            },
        }
    },
    methods:{
        // 提交数据
        save(){
            inviteAdd(this.form).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.$notify({
                    title: '成功',
                    message: '提交成功！',
                    type: 'success'
                });
            });
        },
        // 
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.save();
                } else {
                    this.$message.warning('请检查数据是否为空？');
                    return false;
                }
            });
        },
        pullData(){
            // 获得课程列表
            let arr1 = missionCamp();

            let arr2 = inviteEdit({
                id:this.$route.query.id
            });
            
            this.is_edit = this.$route.query.type === 'edit'?true:false;

            let arr = [arr1];
            if(this.is_edit){
                arr.push(arr2)
            }

            Promise.all(arr).then((data)=>{
                this.course_list = data[0].list;

                // 
                if(this.is_edit){
                    this.form = data[1].list;
                }
                
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss">
.invite-form{
    .el-input,.el-textarea{
        width:800px;
    }
}
</style>
